import { type ReactNode } from "react";
import { NavigationPanelProvider } from "./NavigationPanelProvider";
import { UserProvider } from "./UserProvider";
import { NotificationProvider } from "./NotificationProvider";
import { LocalizationProvider } from "./LocalizationProvider";
import { ThemeProvider } from "./ThemeProvider";
import { LoadingProvider } from "../contexts/loadingContext";
import { ToastProvider } from "./ToastProvider";

export function MainProvider({ children }: { children: ReactNode }) {
  return (
    <main>
      <UserProvider>
        <NotificationProvider>
          <ThemeProvider>
            <LocalizationProvider>
              <ToastProvider>
                <NavigationPanelProvider>
                  <LoadingProvider>{children}</LoadingProvider>
                </NavigationPanelProvider>
              </ToastProvider>
            </LocalizationProvider>
          </ThemeProvider>
        </NotificationProvider>
      </UserProvider>
    </main>
  );
}
